export default __webpack_public_path__ + "static/media/Background_00208.f54bf24d.png";